import React from 'react';
import {API} from "aws-amplify";
import {toast} from "react-toastify";

import InputCell from "@/common/form/InputCell";

export default function AddEditArticleGroup(props){
    var { onCancel, onSuccess, onDelete, existingArticleGroup} = props;

    const titleRef = React.useRef();

    const saveArticleGroup = () => {
        const name = titleRef.current.value.trim();
        if (!name) {
            toast("Group Name cannot be empty.", {position: "top-center", type: "error"});
            return;
        }
        if(existingArticleGroup){
            API.put('Core', '/api/v1/articles/' + existingArticleGroup.id, {body: {name}})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not update ArticleGroup: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
        else{
            API.post('Core', '/api/v1/articles', {body: {name}})
                .then(response => {
                        onSuccess(response);
                    },
                    error => {
                        toast("Could not create ArticleGroup: " + error.response.data.message, {position: "top-center", type: "error"});
                    }
                );
        }
    }

    const deleteArticleGroup = () => {
        if(!existingArticleGroup){
            return;
        }

        API.del('Core', '/api/v1/articles/' + existingArticleGroup.id)
            .then(response => {
                    onDelete();
                },
                error =>{
                    toast("Could not delete article: " + error.response.data.message, {position: "top-center", type: "error"});
                });
    }

    return (
        <div>
            <div className="content">
                <div className="tableView">
                    <div className="tableSection sectionName">
                        <p style={{ fontSize: '0.75em', color: 'var(--colorTitle)', marginBottom: '6px', marginTop: '-4px' }}>
                            Fields marked with <span style={{ color: 'red' }}>*</span> are required.
                        </p>
                        <InputCell
                            placeholder={"Group Name"}
                            defaultValue={(existingArticleGroup ? existingArticleGroup.name : "")}
                            required
                            id="groupName"
                            label="Group"
                            inputRef={titleRef}
                            showRequiredIndicator
                            blurErrorMessage="Group Name cannot be empty."
                        />
                    </div>
                </div>
            </div>
            <div className="actionBar">
                {
                    existingArticleGroup ? (
                        <div className="actions left">
                            <div
                                onClick={deleteArticleGroup}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); deleteArticleGroup(); } }}
                                className="button destructive medium"
                                role="button"
                                tabIndex={0}
                            >
                                <div className="title">Delete</div>
                            </div>
                        </div>
                    ) : null
                }
                <div className="actions">
                    <div
                        onClick={onCancel}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCancel(); } }}
                        className="button dismiss medium"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="title">Cancel</div>
                    </div>

                    <div
                        onClick={saveArticleGroup}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); saveArticleGroup(); } }}
                        className="button confirm medium"
                        role="button"
                        tabIndex={0}
                    >
                        <div className="title">Done</div>
                    </div>
                </div>

                <div className="separator"></div>
            </div>
        </div>
    )
}
